module.exports = {
  BASE_URL: "https://migps-api.kausana.cl",
  BASE_URL_NODE_API: "https://migps-api-mux.kausana.cl",
  URL: 'https://migps-portal.kausana.cl' ,
  WS_URL: "ws://migps-api.kausana.cl",

  DEBUG_MODE: false,
};